import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
import Home from './views/Home.vue'
import Login from './views/login'
import TrainingCamp from './views/trainingCamp'
import TrainingCampEnroll from './views/trainingCamp/enroll'
import Guide from './views/guide'
import Partone from './views/partone'
import Parttwo from './views/parttwo'
import Success from './views/success.vue'

Vue.use(Router)

const requireAuth = (to, from, next) => {
  !getToken() ? (window.location.href = process.env.VUE_APP_LOGIN_URL) : next()
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Home,
      redirect: { name: 'trainingCamp' },
      children: [
        {
          path: '/',
          name: 'trainingCamp',
          component: TrainingCamp,
          beforeEnter: requireAuth
        },
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '/guide',
          name: 'guide',
          component: Guide,
          beforeEnter: requireAuth
        },
        {
          path: '/partone',
          name: 'partone',
          component: Partone,
          beforeEnter: requireAuth
        },
        {
          path: '/parttwo',
          name: 'parttwo',
          component: Parttwo,
          beforeEnter: requireAuth
        },
        {
          path: '/success',
          name: 'success',
          component: Success,
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/trainingCampEnroll',
      name: 'trainingCampEnroll',
      component: TrainingCampEnroll,
      beforeEnter: requireAuth
    }
  ]
})
